// extracted by mini-css-extract-plugin
export var arrow = "_3a-6";
export var changeItem = "_3a-3";
export var changesHeader = "_3a-1";
export var changesList = "_3a-2";
export var container = "_3a-0";
export var pathLabel = "_3a-4";
export var value = "_3a-7";
export var valuesContainer = "_3a-5";